import * as Types from '../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type WholeSyncablePatientFragment = { readonly __typename?: 'SyncablePatient', readonly dob: string, readonly facilityId: string, readonly gender: Types.Gender, readonly id: string, readonly maritalStatus: Types.SyncablePatientMaritalStatus, readonly nationality: string, readonly newToFacility: boolean, readonly organisationId: string, readonly address: { readonly __typename?: 'SyncablePatientAddress', readonly country: string, readonly line1: string, readonly line2: string, readonly line3?: string | null, readonly line4: string }, readonly consent: { readonly __typename?: 'Consent', readonly elephantUseOfAnonData: boolean, readonly productMarketing: boolean, readonly territoryUseOfData: boolean, readonly accessToHealthRecords: boolean, readonly healthcareComms: boolean }, readonly education?: { readonly __typename?: 'Education', readonly isStudent: boolean, readonly school?: string | null, readonly nemisNumber?: string | null } | null, readonly insurance?: { readonly __typename?: 'Insurance', readonly insuranceType: string, readonly insuranceNumber?: string | null, readonly insuranceDetails?: unknown | null } | null, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly createdByUserId: string, readonly deleted: boolean, readonly updatedAt: string, readonly updatedByUserId: string }, readonly name: { readonly __typename?: 'SyncablePatientName', readonly first: string, readonly middle?: string | null, readonly last: string }, readonly nationalId?: { readonly __typename?: 'SyncablePatientNationalId', readonly owner: Types.NationalIdOwner, readonly value: string } | null, readonly nextOfKin?: { readonly __typename?: 'SyncablePatientNextOfKin', readonly fullName: string, readonly phoneNumber?: string | null, readonly relationship?: string | null, readonly address?: { readonly __typename?: 'SyncablePatientNextOfKinAddress', readonly country?: string | null, readonly line1?: string | null, readonly line2?: string | null, readonly line3?: string | null, readonly line4?: string | null } | null } | null, readonly phone?: { readonly __typename?: 'SyncablePatientPhone', readonly number: string, readonly ownership: Types.ContactPointOwnership } | null, readonly registrationFee?: { readonly __typename?: 'SyncablePatientRegistrationFee', readonly paidOn: string, readonly receiptNumber?: string | null } | null, readonly guardians?: ReadonlyArray<{ readonly __typename?: 'Guardian', readonly id: string, readonly patientId?: string | null, readonly fullName?: string | null, readonly relationship: Types.GuardianRelationship, readonly phone?: { readonly __typename?: 'SyncablePatientPhone', readonly number: string, readonly ownership: Types.ContactPointOwnership } | null, readonly consents: { readonly __typename?: 'GuardianConsents', readonly healthcareComms: { readonly __typename?: 'GuardianConsent', readonly value: boolean, readonly providedAt: string }, readonly marketingComms: { readonly __typename?: 'GuardianConsent', readonly value: boolean, readonly providedAt: string } }, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly createdByUserId: string, readonly updatedAt: string, readonly updatedByUserId: string, readonly deleted: boolean } }> | null };

export type SyncPatientPushMutationVariables = Types.Exact<{
  input: Types.PushPatientInput;
}>;


export type SyncPatientPushMutation = { readonly __typename?: 'Mutation', readonly pushPatient: { readonly __typename?: 'PushPatientResponse', readonly rows: ReadonlyArray<{ readonly __typename?: 'SyncablePatient', readonly dob: string, readonly facilityId: string, readonly gender: Types.Gender, readonly id: string, readonly maritalStatus: Types.SyncablePatientMaritalStatus, readonly nationality: string, readonly newToFacility: boolean, readonly organisationId: string, readonly address: { readonly __typename?: 'SyncablePatientAddress', readonly country: string, readonly line1: string, readonly line2: string, readonly line3?: string | null, readonly line4: string }, readonly consent: { readonly __typename?: 'Consent', readonly elephantUseOfAnonData: boolean, readonly productMarketing: boolean, readonly territoryUseOfData: boolean, readonly accessToHealthRecords: boolean, readonly healthcareComms: boolean }, readonly education?: { readonly __typename?: 'Education', readonly isStudent: boolean, readonly school?: string | null, readonly nemisNumber?: string | null } | null, readonly insurance?: { readonly __typename?: 'Insurance', readonly insuranceType: string, readonly insuranceNumber?: string | null, readonly insuranceDetails?: unknown | null } | null, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly createdByUserId: string, readonly deleted: boolean, readonly updatedAt: string, readonly updatedByUserId: string }, readonly name: { readonly __typename?: 'SyncablePatientName', readonly first: string, readonly middle?: string | null, readonly last: string }, readonly nationalId?: { readonly __typename?: 'SyncablePatientNationalId', readonly owner: Types.NationalIdOwner, readonly value: string } | null, readonly nextOfKin?: { readonly __typename?: 'SyncablePatientNextOfKin', readonly fullName: string, readonly phoneNumber?: string | null, readonly relationship?: string | null, readonly address?: { readonly __typename?: 'SyncablePatientNextOfKinAddress', readonly country?: string | null, readonly line1?: string | null, readonly line2?: string | null, readonly line3?: string | null, readonly line4?: string | null } | null } | null, readonly phone?: { readonly __typename?: 'SyncablePatientPhone', readonly number: string, readonly ownership: Types.ContactPointOwnership } | null, readonly registrationFee?: { readonly __typename?: 'SyncablePatientRegistrationFee', readonly paidOn: string, readonly receiptNumber?: string | null } | null, readonly guardians?: ReadonlyArray<{ readonly __typename?: 'Guardian', readonly id: string, readonly patientId?: string | null, readonly fullName?: string | null, readonly relationship: Types.GuardianRelationship, readonly phone?: { readonly __typename?: 'SyncablePatientPhone', readonly number: string, readonly ownership: Types.ContactPointOwnership } | null, readonly consents: { readonly __typename?: 'GuardianConsents', readonly healthcareComms: { readonly __typename?: 'GuardianConsent', readonly value: boolean, readonly providedAt: string }, readonly marketingComms: { readonly __typename?: 'GuardianConsent', readonly value: boolean, readonly providedAt: string } }, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly createdByUserId: string, readonly updatedAt: string, readonly updatedByUserId: string, readonly deleted: boolean } }> | null }> } };

export type SyncPatientPullQueryVariables = Types.Exact<{
  input: Types.PullPatientInput;
}>;


export type SyncPatientPullQuery = { readonly __typename?: 'Query', readonly pullPatient: { readonly __typename?: 'PullPatientResponse', readonly checkpoint?: { readonly __typename?: 'SyncableCheckpoint', readonly id: string, readonly updatedAt: string } | null, readonly documents: ReadonlyArray<{ readonly __typename?: 'SyncablePatient', readonly dob: string, readonly facilityId: string, readonly gender: Types.Gender, readonly id: string, readonly maritalStatus: Types.SyncablePatientMaritalStatus, readonly nationality: string, readonly newToFacility: boolean, readonly organisationId: string, readonly address: { readonly __typename?: 'SyncablePatientAddress', readonly country: string, readonly line1: string, readonly line2: string, readonly line3?: string | null, readonly line4: string }, readonly consent: { readonly __typename?: 'Consent', readonly elephantUseOfAnonData: boolean, readonly productMarketing: boolean, readonly territoryUseOfData: boolean, readonly accessToHealthRecords: boolean, readonly healthcareComms: boolean }, readonly education?: { readonly __typename?: 'Education', readonly isStudent: boolean, readonly school?: string | null, readonly nemisNumber?: string | null } | null, readonly insurance?: { readonly __typename?: 'Insurance', readonly insuranceType: string, readonly insuranceNumber?: string | null, readonly insuranceDetails?: unknown | null } | null, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly createdByUserId: string, readonly deleted: boolean, readonly updatedAt: string, readonly updatedByUserId: string }, readonly name: { readonly __typename?: 'SyncablePatientName', readonly first: string, readonly middle?: string | null, readonly last: string }, readonly nationalId?: { readonly __typename?: 'SyncablePatientNationalId', readonly owner: Types.NationalIdOwner, readonly value: string } | null, readonly nextOfKin?: { readonly __typename?: 'SyncablePatientNextOfKin', readonly fullName: string, readonly phoneNumber?: string | null, readonly relationship?: string | null, readonly address?: { readonly __typename?: 'SyncablePatientNextOfKinAddress', readonly country?: string | null, readonly line1?: string | null, readonly line2?: string | null, readonly line3?: string | null, readonly line4?: string | null } | null } | null, readonly phone?: { readonly __typename?: 'SyncablePatientPhone', readonly number: string, readonly ownership: Types.ContactPointOwnership } | null, readonly registrationFee?: { readonly __typename?: 'SyncablePatientRegistrationFee', readonly paidOn: string, readonly receiptNumber?: string | null } | null, readonly guardians?: ReadonlyArray<{ readonly __typename?: 'Guardian', readonly id: string, readonly patientId?: string | null, readonly fullName?: string | null, readonly relationship: Types.GuardianRelationship, readonly phone?: { readonly __typename?: 'SyncablePatientPhone', readonly number: string, readonly ownership: Types.ContactPointOwnership } | null, readonly consents: { readonly __typename?: 'GuardianConsents', readonly healthcareComms: { readonly __typename?: 'GuardianConsent', readonly value: boolean, readonly providedAt: string }, readonly marketingComms: { readonly __typename?: 'GuardianConsent', readonly value: boolean, readonly providedAt: string } }, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly createdByUserId: string, readonly updatedAt: string, readonly updatedByUserId: string, readonly deleted: boolean } }> | null }> } };

export const WholeSyncablePatientFragmentDoc = gql`
    fragment WholeSyncablePatient on SyncablePatient {
  address {
    country
    line1
    line2
    line3
    line4
  }
  consent {
    elephantUseOfAnonData
    productMarketing
    territoryUseOfData
    accessToHealthRecords
    healthcareComms
  }
  dob
  education {
    isStudent
    school
    nemisNumber
  }
  facilityId
  gender
  id
  insurance {
    insuranceType
    insuranceNumber
    insuranceDetails
  }
  maritalStatus
  meta {
    createdAt
    createdByUserId
    deleted
    updatedAt
    updatedByUserId
  }
  name {
    first
    middle
    last
  }
  nationalId {
    owner
    value
  }
  nationality
  newToFacility
  nextOfKin {
    address {
      country
      line1
      line2
      line3
      line4
    }
    fullName
    phoneNumber
    relationship
  }
  organisationId
  phone {
    number
    ownership
  }
  registrationFee {
    paidOn
    receiptNumber
  }
  guardians {
    id
    patientId
    fullName
    phone {
      number
      ownership
    }
    relationship
    consents {
      healthcareComms {
        value
        providedAt
      }
      marketingComms {
        value
        providedAt
      }
    }
    meta {
      createdAt
      createdByUserId
      updatedAt
      updatedByUserId
      deleted
    }
  }
}
    `;
export const SyncPatientPushDocument = gql`
    mutation SyncPatientPush($input: PushPatientInput!) {
  pushPatient(input: $input) {
    rows {
      ...WholeSyncablePatient
    }
  }
}
    ${WholeSyncablePatientFragmentDoc}`;
export type SyncPatientPushMutationFn = Apollo.MutationFunction<SyncPatientPushMutation, SyncPatientPushMutationVariables>;

/**
 * __useSyncPatientPushMutation__
 *
 * To run a mutation, you first call `useSyncPatientPushMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncPatientPushMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncPatientPushMutation, { data, loading, error }] = useSyncPatientPushMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncPatientPushMutation(baseOptions?: Apollo.MutationHookOptions<SyncPatientPushMutation, SyncPatientPushMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncPatientPushMutation, SyncPatientPushMutationVariables>(SyncPatientPushDocument, options);
      }
export type SyncPatientPushMutationHookResult = ReturnType<typeof useSyncPatientPushMutation>;
export type SyncPatientPushMutationResult = Apollo.MutationResult<SyncPatientPushMutation>;
export type SyncPatientPushMutationOptions = Apollo.BaseMutationOptions<SyncPatientPushMutation, SyncPatientPushMutationVariables>;
export const SyncPatientPullDocument = gql`
    query SyncPatientPull($input: PullPatientInput!) {
  pullPatient(input: $input) {
    checkpoint {
      id
      updatedAt
    }
    documents {
      ...WholeSyncablePatient
    }
  }
}
    ${WholeSyncablePatientFragmentDoc}`;

/**
 * __useSyncPatientPullQuery__
 *
 * To run a query within a React component, call `useSyncPatientPullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSyncPatientPullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSyncPatientPullQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncPatientPullQuery(baseOptions: Apollo.QueryHookOptions<SyncPatientPullQuery, SyncPatientPullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SyncPatientPullQuery, SyncPatientPullQueryVariables>(SyncPatientPullDocument, options);
      }
export function useSyncPatientPullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SyncPatientPullQuery, SyncPatientPullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SyncPatientPullQuery, SyncPatientPullQueryVariables>(SyncPatientPullDocument, options);
        }
export type SyncPatientPullQueryHookResult = ReturnType<typeof useSyncPatientPullQuery>;
export type SyncPatientPullLazyQueryHookResult = ReturnType<typeof useSyncPatientPullLazyQuery>;
export type SyncPatientPullQueryResult = Apollo.QueryResult<SyncPatientPullQuery, SyncPatientPullQueryVariables>;